

































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { ScenarioTypeInterface } from "@/resources/interfaces/spaceInterfaces";
@Component({
  name: "modal-select-scene-component",
})
export default class ModalSelectSceneComponent extends Vue {
  @Prop(Number) readonly sceneTypeId: number;
  @Prop({ default: false }) active!: boolean;
  sceneTypeList = [];

  get openModal(): boolean {
    return this.active;
  }
  set openModal(e) {
    this.$emit("close-modal", e);
  }
  get filterSceneBySpaceType(): Array<ScenarioTypeInterface> {
    const sceneTypes = this.$store.getters["SpaceStore/getSceneTypes"];
    return sceneTypes;
  }
  selectScene(scene: any): void {
    this.$emit("select-scene", scene);
    this.openModal = false;
  }
}
